import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { signOut } from '../../firebase/models/authService';
import { useAuth } from '../../context/AuthContext';

const DashboardContainer = styled.div`
  padding: var(--spacing-xl);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-xl);
`;

const Title = styled.h1`
  margin: 0;
`;

const NavContainer = styled.div`
  display: flex;
  gap: var(--spacing-md);
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: var(--accent-blue);
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Button = styled.button`
  padding: var(--spacing-sm) var(--spacing-md);
  background-color: var(--accent-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background-color: var(--dark-blue);
  }
`;

const Card = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
`;

const CardTitle = styled.h2`
  margin-top: 0;
  margin-bottom: var(--spacing-md);
`;

const CardContent = styled.div`
  display: flex;
  gap: var(--spacing-lg);
`;

const Section = styled.div`
  flex: 1;
`;

const AdminLink = styled(Link)`
  display: block;
  padding: var(--spacing-md);
  background-color: #f5f5f5;
  border-radius: 4px;
  text-decoration: none;
  color: var(--text-color);
  margin-bottom: var(--spacing-md);
  
  &:hover {
    background-color: #e5e5e5;
  }
`;

const Dashboard = () => {
  const { currentUser } = useAuth();
  
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  
  return (
    <DashboardContainer>
      <Header>
        <Title>Admin Dashboard</Title>
        <NavContainer>
          <StyledLink to="/blog">View Blog</StyledLink>
          <Button onClick={handleSignOut}>Sign Out</Button>
        </NavContainer>
      </Header>
      
      <Card>
        <CardTitle>Blog Management</CardTitle>
        <CardContent>
          <Section>
            <AdminLink to="/admin/posts">
              Manage Blog Posts
            </AdminLink>
            <AdminLink to="/admin/categories">
              Manage Categories
            </AdminLink>
          </Section>
          <Section>
            <AdminLink to="/admin/posts/new">
              Create New Post
            </AdminLink>
            <AdminLink to="/admin/categories/new">
              Create New Category
            </AdminLink>
          </Section>
        </CardContent>
      </Card>
      
      <Card>
        <CardTitle>Account</CardTitle>
        <p>Logged in as: {currentUser?.email}</p>
      </Card>
    </DashboardContainer>
  );
};

export default Dashboard; 